import { render } from "./ManageMedia.vue?vue&type=template&id=e4ec368a&lang=pug"
import script from "./ManageMedia.vue?vue&type=script&lang=js"
export * from "./ManageMedia.vue?vue&type=script&lang=js"

import "./ManageMedia.vue?vue&type=style&index=0&id=e4ec368a&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__